import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MaterialModule } from '../../material.module';
import { ClockComponent } from './clock/clock.component';

@NgModule({
  declarations: [ClockComponent],
  imports: [CommonModule, MaterialModule],
  exports: [ClockComponent],
})
export class TimeModule {}
